import log from '@/logger';
import {
  checkResponseForMaintenance,
  checkResponseForTaxInfo,
  checkResponseVersion,
  checkResponseForDocumentUpload,
} from './utils';

export default (response) => {
  checkResponseForMaintenance(response);
  checkResponseForTaxInfo(response);
  checkResponseForDocumentUpload(response);
  checkResponseVersion(response);
  const isSensitiveResponse =
    /api\/(?:User\/Wallet\/(?:BankLinks|.*DepositBankTransfer)|Account\/token)/i.test(
      response.config.url || '',
    );
  if (!response.config.bankDiagnostic) {
    // Banking session responses include provider credentials; never dump the body.
    log.info(
      'API - SUCCESS',
      response.status,
      response.config.method,
      response.config.url,
      isSensitiveResponse ? '[sensitive response omitted]' : response,
    );
  }
  return response;
};
